import { useMutation, useQuery } from "@apollo/client";
import { CancelServiceOrderForm } from "components/forms";
import { Modal } from "components/layouts";
import { useFormik } from "formik";
import toast from "react-hot-toast";
import { useSearch } from "react-location";
import { LocationGenerics } from "router/location";
import { wrapClick } from "utils";
import { CANCEL_SERVICE_ORDER, GET_SERVICE_ORDER } from "./apollo";

export default function CancelRATServiceOrderContainer({
  open,
  setOpen,
  refetch,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
  refetch?: () => void;
}) {
  const searchParams = useSearch<LocationGenerics>();
  const { data, loading } = useQuery(GET_SERVICE_ORDER, {
    variables: {
      id: searchParams.id,
    },
    notifyOnNetworkStatusChange: false,
    skip: !searchParams.id,
  });

  const [cancelServiceOrder] = useMutation(CANCEL_SERVICE_ORDER);

  const order = data?.serviceOrder;

  const form = useFormik({
    initialValues: {
      reason: "",
    },
    onSubmit: async (values) => {
      await cancelServiceOrder({
        variables: {
          id: searchParams.id,
          ...values,
        },
      }).then(({ data: result }) => {
        if (result?.cancelServiceOrder?._id) {
          toast(
            JSON.stringify({
              type: "success",
              title: "RAT Service Order Cancelled Successfully",
            }),
          );
          form.resetForm();
          refetch?.();
          setOpen(false);
        } else {
          toast(
            JSON.stringify({
              type: "error",
              title: "Could not cancel RAT Service Order",
            }),
          );
        }
      });
    },
    onReset: () => {
      setOpen(false);
    },
  });

  const canCancel = ["Pending", "Assigned", "InProgress"].includes(
    order?.status || "",
  );

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      title="Cancel RAT Service Order"
      description={
        order
          ? `Provide a reason for cancelling order ${order.code} for ${order.contactPerson?.fullName || "this customer"}.`
          : "Provide a reason for cancelling this RAT service order."
      }
      loading={loading}
      renderActions={() => (
        <>
          {canCancel ? (
            <button
              type="button"
              disabled={form.isSubmitting}
              className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary-600 text-base font-medium text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 sm:ml-3 sm:w-auto sm:text-sm"
              onClick={wrapClick(form.handleSubmit)}
            >
              {form.isSubmitting ? "Cancelling..." : "Cancel Order"}
            </button>
          ) : null}
        </>
      )}
    >
      {order?._id && canCancel && <CancelServiceOrderForm form={form} />}
    </Modal>
  );
}
